import React from 'react';
import styled, { css } from 'styled-components';

const AnimatedEllipsis = styled.span`
  .one {
    opacity: 1;
    animation: dot 1.3s infinite;
    animation-delay: 0s;
  }

  .two {
    opacity: 1;
    animation: dot 1.3s infinite;
    animation-delay: 0.2s;
  }

  .three {
    opacity: 1;
    animation: dot 1.3s infinite;
    animation-delay: 0.3s;
  }

  @keyframes dot {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

function EllipsisAnimation(props) {
  return (
    <AnimatedEllipsis {...props}>
      <span className="one">.</span>
      <span className="two">.</span>
      <span className="three">.</span>
    </AnimatedEllipsis>
  );
}

export default styled(EllipsisAnimation)`
  font-size: 2em;
  ${props =>
    props.small &&
    css`
      font-size: 1em;
    `};
`;



// WEBPACK FOOTER //
// ./src/app/components/AnimatedEllipsis.js